import currency, { removeZeroCents } from '|/helpers/currency';
import type { VehicleSummary } from './types';

export const formatCurrency = (amount: number): string => removeZeroCents(currency(amount));

export type LabelFor = (value: number) => { label: string; amount: number };

export const cashLabel = (
  value: number,
  showTotalDue = false
): { label: string; amount: number } =>
  value < 0
    ? { label: 'Refund', amount: Math.abs(value) }
    : { label: showTotalDue ? 'Total due at order' : 'Total price', amount: value };

export const safLabel: LabelFor = value =>
  value < 0
    ? { label: 'Refund', amount: Math.abs(value) }
    : { label: 'Due to Carvana', amount: value };

export const financeTotalLabel: LabelFor = value => {
  if (value < 0) return { label: 'Refund', amount: Math.abs(value) };
  if (value === 0) return { label: 'Due', amount: 0 };
  return { label: 'Total due', amount: value };
};

export const getNonFinanceLabel = (summary: VehicleSummary): { label: string; amount: number } => {
  const { purchaseType, totalPurchasePrice = 0, showTotalDue } = summary;
  return purchaseType === 'saf'
    ? safLabel(totalPurchasePrice)
    : cashLabel(totalPurchasePrice, showTotalDue);
};
